(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caltech-best-sellers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('caltech-best-sellers')) {
  customElements.define('caltech-best-sellers', class extends HTMLElement {
    connectedCallback() {
      if (this.scope) return;
      this.scope = new AbortController();
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.total = this.cards.length;
      if (!this.total) return;
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.cooldown = 0;
      this.busy = false;
      const on = (target, event, handler, options = {}) => target.addEventListener(event, handler, {...options, signal:this.scope.signal});
      this.cards.slice(0, 4).forEach(card => {
        const clone = card.cloneNode(true);
        clone.removeAttribute('data-card');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        this.track.append(clone);
      });
      this.setAttribute('data-ready', '');
      this.querySelector('[data-controls]').hidden = this.total < 2;
      on(this.querySelector('[data-next]'), 'click', () => this.move(1));
      on(this.querySelector('[data-previous]'), 'click', () => this.move(-1));
      on(this.querySelector('[data-rotation]'), 'click', () => {
        this.manualPause = !this.manualPause;
        this.rotationLabel();
        this.schedule();
      });
      on(this, 'pointerenter', event => {this.hovered = event.pointerType !== 'touch'; this.schedule();});
      on(this, 'pointerleave', () => {this.hovered = false; this.schedule();});
      on(this, 'focusin', () => {this.focused = true; this.schedule();});
      on(this, 'focusout', () => queueMicrotask(() => {if (this.isConnected) {this.focused = this.contains(document.activeElement); this.schedule();}}));
      on(document, 'visibilitychange', () => this.schedule());
      on(this.reduced, 'change', event => {if (event.matches) this.manualPause = true; this.rotationLabel(); this.render(false); this.schedule();});
      on(this.track, 'transitionend', event => {if (event.propertyName === 'transform') this.finish();});
      on(this.viewport, 'dragstart', event => event.preventDefault());
      on(this.viewport, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.viewport.focus({preventScroll:true});
        if (event.key === 'Home' || event.key === 'End') {this.index = event.key === 'Home' ? 0 : this.total - 1; this.render(false); this.schedule();}
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      });
      on(this.viewport, 'pointerdown', event => {
        if (event.button !== 0) return;
        this.drag = {x:event.clientX, y:event.clientY, id:event.pointerId, horizontal:false};
        this.schedule();
      });
      on(window, 'pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const dx = event.clientX - this.drag.x, dy = event.clientY - this.drag.y;
        if (!this.drag.horizontal && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) + 4) {
          this.drag.horizontal = true;
          this.viewport.setPointerCapture(event.pointerId);
        }
        if (this.drag.horizontal && event.cancelable) event.preventDefault();
      }, {passive:false});
      const release = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const drag = this.drag;
        this.drag = null;
        if (drag.horizontal) {
          this.ignoreClickUntil = performance.now() + 400;
          this.cooldown = Date.now() + 8000;
          if (Math.abs(event.clientX - drag.x) > 30) this.move(event.clientX < drag.x ? 1 : -1);
        }
        this.schedule();
      };
      on(window, 'pointerup', release);
      on(window, 'pointercancel', () => {this.drag = null; this.schedule();});
      on(this, 'click', event => {if (performance.now() < (this.ignoreClickUntil || 0) && event.target.closest('a')) {event.preventDefault(); event.stopPropagation();}}, {capture:true});
      on(document, 'shopify:block:select', event => {
        const card = event.target.closest('[data-card]');
        if (!card || !this.contains(card)) return;
        this.editorPause = true; this.index = this.cards.indexOf(card); this.render(false); this.schedule();
      });
      on(document, 'shopify:block:deselect', () => {this.editorPause = false; this.schedule();});
      this.resize = new ResizeObserver(() => {this.index %= this.total; this.busy = false; clearTimeout(this.settleTimer); this.render(false); this.schedule();});
      this.resize.observe(this.viewport);
      this.intersection = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting; this.schedule();}, {threshold:.1});
      this.intersection.observe(this);
      this.render(false);
      this.rotationLabel();
    }
    rotationLabel() {
      this.querySelector('[data-rotation-label]').textContent = this.manualPause ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.querySelector('[data-rotation]').setAttribute('aria-pressed', String(this.manualPause));
    }
    render(animate) {
      if (!this.total) return;
      const width = this.cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.step = width + gap;
      this.visibleCount = Math.max(1, Math.round((this.viewport.clientWidth + gap) / this.step));
      this.track.style.transition = animate && !this.reduced.matches ? 'transform 650ms ease' : 'none';
      this.track.style.transform = `translateX(${-this.index * this.step}px)`;
      const current = this.index % this.total;
      this.cards.forEach((card, i) => {
        const showing = i >= this.index && i < this.index + this.visibleCount;
        card.inert = !showing;
        card.setAttribute('aria-hidden', String(!showing));
      });
      this.querySelectorAll('[data-clone]').forEach((card, i) => {
        const showing = this.total + i >= this.index && this.total + i < this.index + this.visibleCount;
        card.inert = !showing;
        card.setAttribute('aria-hidden', String(!showing));
      });
      this.querySelector('[data-count]').textContent = `${current + 1} / ${this.total}`;
    }
    move(direction) {
      if (this.busy || this.total < 2) return;
      clearTimeout(this.timer);
      if (direction < 0 && this.index === 0) {this.index = this.total; this.render(false); this.track.getBoundingClientRect();}
      this.index += direction;
      this.busy = true;
      this.render(true);
      this.settleTimer = setTimeout(() => this.finish(), this.reduced.matches ? 0 : 700);
    }
    finish() {
      clearTimeout(this.settleTimer);
      if (!this.busy) return;
      this.busy = false;
      if (this.index >= this.total) {this.index = 0; this.render(false);}
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.scope || this.manualPause || this.hovered || (matchMedia('(hover: hover)').matches && this.matches(':hover')) || this.focused || this.drag || this.editorPause || !this.visible || document.hidden || this.busy || this.total <= this.visibleCount) return;
      const delay = Math.max(Number(this.dataset.interval) || 4500, this.cooldown - Date.now());
      this.timer = setTimeout(() => this.move(1), delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer); clearTimeout(this.settleTimer);
      this.scope?.abort(); this.scope = null;
      this.resize?.disconnect(); this.intersection?.disconnect();
      this.querySelectorAll('[data-clone]').forEach(card => card.remove());
      this.removeAttribute('data-ready');
      this.cards?.forEach(card => {card.inert = false; card.removeAttribute('aria-hidden');});
      if (this.track) {this.track.style.transform = ''; this.track.style.transition = '';}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caltech-collection-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('caltech-collection-fan')) {
  customElements.define('caltech-collection-fan', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal:this.controller.signal };
      const start = () => {
        if (!this.isConnected || this.initialized) return;
        this.grid = this.querySelector('.ct-collections__grid');
        this.items = Array.from(this.querySelectorAll('.ct-collections__item'));
        this.links = this.items.map(item => item.querySelector('.ct-collections__card'));
        this.dots = Array.from(this.querySelectorAll('.ct-collections__fan-dot'));
        this.status = this.querySelector('.ct-collections__status');
        if (!this.grid || this.items.length < 2) return;
        this.initialized = true;
        this.active = 0;
        this.hovering = false;
        this.focused = false;
        this.visible = false;
        this.editing = false;
        this.manualPause = false;
        this.interval = Math.max(2000, Number(this.dataset.interval) || 3000);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.classList.add('ct-collections--fan-ready');
        this.setAttribute('aria-roledescription', 'carousel');
        this.layout = () => {
          const width = this.grid.clientWidth;
          const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const heading = this.querySelector('.ct-collections__header').getBoundingClientRect().height;
          const height = Math.max(width < 600 ? 310 : 300, Math.min(460, innerHeight - header - heading - 140));
          this.cardWidth = Math.max(220, Math.min(width < 600 ? width * .80 : width * .56, 400, height * 1.02));
          this.style.setProperty('--ctc-fan-width', this.cardWidth + 'px');
          this.style.setProperty('--ctc-fan-card-height', height + 'px');
          this.style.setProperty('--ctc-fan-height', (height + 130) + 'px');
          this.maxOffset = width < 600 ? 1 : 2;
          this.spacing = this.cardWidth * (width < 600 ? .29 : .43);
          this.paint();
        };
        this.paint = () => {
          this.items.forEach((item, index) => {
            let offset = index - this.active;
            const wrapped = offset > 0 ? offset - this.items.length : offset + this.items.length;
            if (Math.abs(wrapped) < Math.abs(offset)) offset = wrapped;
            const distance = Math.abs(offset);
            const active = distance === 0;
            const visible = distance <= this.maxOffset;
            const drag = active && this.drag?.dragging ? this.drag.delta : 0;
            item.dataset.active = String(active);
            item.dataset.visible = String(visible);
            item.style.setProperty('--ctc-fan-x', (offset * this.spacing + drag) + 'px');
            item.style.setProperty('--ctc-fan-y', (active ? -20 : distance * 10) + 'px');
            item.style.setProperty('--ctc-fan-z', (-distance * 75) + 'px');
            item.style.setProperty('--ctc-fan-angle', (offset * (this.maxOffset === 1 ? 10 : 12)) + 'deg');
            item.style.setProperty('--ctc-fan-tilt', (active ? 0 : 8) + 'deg');
            item.style.setProperty('--ctc-fan-scale', active ? '1.02' : '.94');
            item.style.setProperty('--ctc-fan-opacity', visible ? '1' : '0');
            item.style.setProperty('--ctc-fan-layer', String(20 - distance));
            item.setAttribute('aria-hidden', String(!active));
            this.links[index].tabIndex = active ? 0 : -1;
            this.links[index].draggable = false;
            this.dots[index].setAttribute('aria-current', String(active));
          });
        };
        this.select = (index, announce = true) => {
          const moveFocus = this.items.some(item => item.contains(document.activeElement));
          this.active = ((index % this.items.length) + this.items.length) % this.items.length;
          this.paint();
          if (moveFocus) this.links[this.active].focus({preventScroll:true});
          if (announce) this.status.textContent = this.links[this.active].querySelector('.ct-collections__title').textContent + ', ' + (this.active + 1) + ' of ' + this.items.length;
          this.schedule();
        };
        this.schedule = () => {
          clearTimeout(this.timer);
          const paused = this.manualPause || this.motion.matches || this.editing || this.dataset.autoplay !== 'true';
          if (this.dataset.autoplay !== 'true' || paused || this.hovering || this.focused || !this.visible || document.hidden || this.drag) return;
          this.timer = setTimeout(() => this.select(this.active + 1, false), this.interval);
        };
        this.querySelector('[data-fan-prev]').addEventListener('click', () => this.select(this.active - 1), options);
        this.querySelector('[data-fan-next]').addEventListener('click', () => this.select(this.active + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index), options));
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovering = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovering = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', () => { queueMicrotask(() => { if (this.isConnected) { this.focused = this.contains(document.activeElement); this.schedule(); } }); }, options);
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          this.select(event.key === 'Home' ? 0 : event.key === 'End' ? this.items.length - 1 : this.active + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.grid.addEventListener('click', event => {
          const index = this.links.indexOf(event.target.closest('.ct-collections__card'));
          if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; return; }
          if (index !== -1 && index !== this.active) { event.preventDefault(); this.select(index); }
        }, options);
        this.grid.addEventListener('dragstart', event => event.preventDefault(), options);
        this.grid.addEventListener('pointerdown', event => {
          if (event.button !== 0 || !event.isPrimary || !event.target.closest('[data-active="true"]')) return;
          this.suppressClick = false;
          this.drag = {id:event.pointerId, x:event.clientX, y:event.clientY, time:performance.now(), delta:0, dragging:false};
          this.schedule();
        }, options);
        this.grid.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const dx = event.clientX - this.drag.x;
          const dy = event.clientY - this.drag.y;
          if (!this.drag.dragging && Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { this.drag = null; this.schedule(); return; }
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.drag.dragging = true;
            this.grid.setPointerCapture(event.pointerId);
            this.classList.add('ct-collections--dragging');
          }
          if (this.drag.dragging) { this.drag.delta = dx; this.paint(); }
        }, options);
        const finishDrag = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const drag = this.drag;
          this.drag = null;
          this.classList.remove('ct-collections--dragging');
          if (this.grid.hasPointerCapture(event.pointerId)) this.grid.releasePointerCapture(event.pointerId);
          this.suppressClick = drag.dragging;
          const velocity = drag.delta / Math.max(1, performance.now() - drag.time);
          if (event.type === 'pointerup' && drag.dragging && (Math.abs(drag.delta) > Math.min(100, this.cardWidth * .20) || Math.abs(velocity) > .65)) this.select(this.active + (drag.delta < 0 ? 1 : -1));
          else { this.paint(); this.schedule(); }
        };
        this.grid.addEventListener('pointerup', finishDrag, options);
        this.grid.addEventListener('pointercancel', finishDrag, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => { try { const block = JSON.parse(item.getAttribute('data-shopify-editor-block') || '{}'); return block.id === event.detail.blockId; } catch { return false; } });
          this.editing = true;
          if (index >= 0) this.select(index); else this.schedule();
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.schedule(); }, options);
        document.addEventListener('visibilitychange', this.schedule, options);
        this.motion.addEventListener('change', this.schedule, options);
        window.addEventListener('resize', this.layout, options);
        this.resize = new ResizeObserver(this.layout);
        this.resize.observe(this.grid);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, {threshold:0});
        this.observer.observe(this.grid);
        document.fonts.ready.then(() => { if (this.isConnected) this.layout(); });
        this.layout();
        this.schedule();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {...options, once:true}); else start();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.controller = null;
      this.initialized = false;
      this.drag = null;
      this.suppressClick = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('caltech-reviews')) {
  customElements.define('caltech-reviews', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.ctr__viewport');
      this.track = this.querySelector('.ctr__track');
      this.cards = Array.from(this.querySelectorAll('.ctr__card'));
      if (!this.cards.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manual = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.editing = false;
      this.visible = true;
      this.frame = 0;
      this.lastTime = 0;
      this.classList.add('is-ready');
      this.measure = () => {
        this.stepWidth = this.cards[0].getBoundingClientRect().width + 24;
        this.cards.forEach(card => {
          const text = card.querySelector('.ctr__quote p');
          card.querySelector('.ctr__expand').hidden = !card.classList.contains('is-expanded') && text.scrollHeight <= text.clientHeight + 1;
        });
      };
      this.resize = new ResizeObserver(this.measure);
      this.resize.observe(this.viewport);
      this.measure();
      document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { this.hovered = true; this.sync(); } }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.viewport.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.viewport.addEventListener('focusout', event => { if (!this.viewport.contains(event.relatedTarget)) { this.focused = false; this.sync(); } }, options);
      this.viewport.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') { this.manual = true; this.sync(); } }, options);
      this.viewport.addEventListener('wheel', () => { this.manual = true; this.sync(); }, { ...options, passive: true });
      this.viewport.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.step(event.key === 'ArrowRight' ? 1 : -1); } }, options);
      this.querySelector('[data-action="toggle"]').addEventListener('click', () => { this.manual = !this.manual; this.sync(); }, options);
      this.querySelector('[data-action="previous"]').addEventListener('click', () => this.step(-1), options);
      this.querySelector('[data-action="next"]').addEventListener('click', () => this.step(1), options);
      this.querySelectorAll('.ctr__expand').forEach(button => button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
        button.closest('.ctr__card').classList.toggle('is-expanded', expanded);
        this.manual = true;
        this.sync();
      }, options));
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { this.manual = this.motion.matches; this.sync(); }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.reviewId === event.detail.blockId);
        if (card) { this.editing = true; this.viewport.scrollLeft = card.offsetLeft; this.sync(); }
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.sync(); }, options);
      this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
      this.intersection.observe(this);
      this.tick = time => {
        if (this.lastTime && this.stepWidth > 0) {
          const movement = Math.min(time - this.lastTime, 50) / 1000 * (Number(this.dataset.speed) || 34);
          this.move(movement);
        }
        this.lastTime = time;
        this.frame = requestAnimationFrame(this.tick);
      };
      this.sync();
    }
    sync() {
      const paused = this.manual || this.hovered || this.focused || this.editing;
      this.classList.toggle('is-paused', paused);
      this.querySelector('.ctr__toggle span').textContent = paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
      this.querySelector('.ctr__toggle').setAttribute('aria-pressed', String(this.manual));
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.lastTime = 0;
      this.position = this.viewport.scrollLeft;
      if (!paused && this.visible && !document.hidden && this.cards.length > 1) this.frame = requestAnimationFrame(this.tick);
    }
    step(direction) {
      this.manual = true;
      this.sync();
      this.move(direction * this.stepWidth);
    }
    move(distance) {
      if (!(this.stepWidth > 0) || this.cards.length < 2) return;
      this.position += distance;
      while (this.position >= this.stepWidth) {
        this.track.appendChild(this.track.firstElementChild);
        this.position -= this.stepWidth;
      }
      while (this.position < 0) {
        this.track.prepend(this.track.lastElementChild);
        this.position += this.stepWidth;
      }
      this.viewport.scrollLeft = this.position;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-3d-waves"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ct-shop-hero')) {
    customElements.define('ct-shop-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.ctBound) return;
        this.ctBound = true;
        this.ctMonitor = this.querySelector('[data-ct-monitor-motion]');
        this.ctMotionButton = this.querySelector('[data-ct-monitor-toggle]');
        this.ctHeroImage = this.querySelector('.ct-hero__image');
        if (this.ctMonitor && this.ctMotionButton && this.ctHeroImage) {
          this.ctMotionPaused = false;
          this.ctMotionVisible = true;
          this.ctMotionReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.ctMotionMobile = window.matchMedia('(max-width: 999px)');
          this.ctUpdateMonitor = () => {
            const suppressed = this.ctMotionMobile.matches && this.ctMonitor.dataset.customMobile === 'true';
            const ready = this.ctHeroImage.complete && this.ctHeroImage.naturalWidth > 0;
            const source = this.ctMonitor.querySelector('[data-ct-monitor-source]');
            const currentSource = this.ctHeroImage.currentSrc || this.ctHeroImage.src;
            if (ready && source.getAttribute('href') !== currentSource) source.setAttribute('href', currentSource);
            this.ctMonitor.setAttribute('preserveAspectRatio', this.ctMotionMobile.matches ? 'xMaxYMid slice' : 'xMidYMax meet');
            this.ctMonitor.dataset.ready = String(ready);
            this.ctMonitor.dataset.suppressed = String(suppressed);
            const paused = this.ctMotionPaused || this.ctMotionReduced.matches || !this.ctMotionVisible || document.hidden || suppressed || !ready;
            if (paused) this.ctMonitor.pauseAnimations();
            else this.ctMonitor.unpauseAnimations();
            this.ctMotionButton.hidden = suppressed || this.ctMotionReduced.matches || !ready;
            this.ctMotionButton.dataset.paused = String(this.ctMotionPaused);
            this.ctMotionButton.setAttribute('aria-label', this.ctMotionPaused ? this.ctMotionButton.dataset.playLabel : this.ctMotionButton.dataset.pauseLabel);
          };
          this.ctToggleMonitor = () => {
            this.ctMotionPaused = !this.ctMotionPaused;
            this.ctUpdateMonitor();
          };
          this.ctHeroImage.addEventListener('load', this.ctUpdateMonitor);
          this.ctMotionButton.addEventListener('click', this.ctToggleMonitor);
          this.ctMotionReduced.addEventListener('change', this.ctUpdateMonitor);
          this.ctMotionMobile.addEventListener('change', this.ctUpdateMonitor);
          document.addEventListener('visibilitychange', this.ctUpdateMonitor);
          if ('IntersectionObserver' in window) {
            this.ctMotionObserver = new IntersectionObserver((entries) => {
              this.ctMotionVisible = entries[0].isIntersecting;
              this.ctUpdateMonitor();
            });
            this.ctMotionObserver.observe(this);
          }
          this.ctUpdateMonitor();
        }
        this.ctClose = (event) => {
          const openMenus = this.querySelectorAll('details[open]');
          openMenus.forEach((menu) => {
            if (!menu.contains(event.target)) menu.open = false;
          });
        };
        this.ctEscape = (event) => {
          if (event.key !== 'Escape') return;
          const menu = event.target.closest('details[open]');
          if (!menu || !this.contains(menu)) return;
          menu.open = false;
          menu.querySelector('summary').focus();
          event.preventDefault();
        };
        this.ctToggle = (event) => {
          const target = event.target;
          if (!(target instanceof HTMLDetailsElement) || !target.open) return;
          this.querySelectorAll('details[open]').forEach((menu) => {
            if (menu !== target) menu.open = false;
          });
        };
        document.addEventListener('pointerdown', this.ctClose);
        document.addEventListener('focusin', this.ctClose);
        this.addEventListener('keydown', this.ctEscape);
        this.addEventListener('toggle', this.ctToggle, true);
      }
      disconnectedCallback() {
        if (this.ctMonitor && this.ctMotionButton && this.ctHeroImage) {
          this.ctMonitor.pauseAnimations();
          this.ctMotionObserver?.disconnect();
          this.ctHeroImage.removeEventListener('load', this.ctUpdateMonitor);
          this.ctMotionButton.removeEventListener('click', this.ctToggleMonitor);
          this.ctMotionReduced.removeEventListener('change', this.ctUpdateMonitor);
          this.ctMotionMobile.removeEventListener('change', this.ctUpdateMonitor);
          document.removeEventListener('visibilitychange', this.ctUpdateMonitor);
        }
        document.removeEventListener('pointerdown', this.ctClose);
        document.removeEventListener('focusin', this.ctClose);
        this.removeEventListener('keydown', this.ctEscape);
        this.removeEventListener('toggle', this.ctToggle, true);
        this.ctBound = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
